var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "wrapper",
      class: { sticky: _vm.isHeaderSticky },
      attrs: { id: "header" },
    },
    [
      _c(
        "div",
        {
          staticClass: "md:flex flex-wrap align-center",
          attrs: { id: "logo-container" },
        },
        [
          _c("div", { staticClass: "col xs-6 sm-4 md-2 lg-2" }, [
            _c("a", { attrs: { href: _vm.webstoreUrl } }, [
              _c("img", {
                attrs: {
                  src: "https://images.ctfassets.net/bx9krvy0u3sx/6V8G7V8dZCwYaMGs2Seys4/e81e482585ffc6219d377eed5a33743c/logo.svg",
                  alt: "samsara",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.categoryFilter.display
            ? _c(
                "div",
                {
                  staticClass: "col xs-12 sm-12 md-5 lg-4 flex flex-between",
                  attrs: { id: "category-container" },
                },
                _vm._l(_vm.categories, function (category) {
                  return _c(
                    "li",
                    {
                      key: category,
                      staticClass: "categories",
                      class:
                        _vm.selectedCategory === category
                          ? "selected"
                          : "not-selected",
                      on: {
                        click: function ($event) {
                          return _vm.handleMenuItemClick(category)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.categoryFilter[category.toLowerCase()]) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex justify-start",
              attrs: { id: "right-header-container" },
            },
            [
              _vm.isAnonymousCustomer
                ? _c("div", { staticClass: "ml-auto pr-2" }, [_vm._m(0)])
                : _vm._e(),
              _vm._v(" "),
              _vm.anonymousLargeFleet &&
              _vm.pricingModalComplete &&
              _vm.productCatalogPage
                ? _c("div", { staticClass: "ml-auto pr-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "inquire",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("anonymous-inquiry")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Inquire\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.baselinePhoenixChanges && _vm.activePage === "review"
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "flex gap-1 justify-center md:justify-end",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "md:m-auto my-auto text-xl w-30" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.renewalsPersistedVariables.jsonContent.text
                                  .gotQuestions
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "contact-us",
                            on: {
                              click: function ($event) {
                                return _vm.$emit("contact-us")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "text-xl" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.renewalsPersistedVariables.jsonContent
                                    .buttons.contactUs
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.shoppingBag.display
                ? _c(
                    "div",
                    {
                      staticClass: "flex flex-center",
                      attrs: { id: "shopping-cart-container" },
                      on: { click: _vm.handleShoppingBagClick },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            id: "shopping-cart-icon",
                            width: "25",
                            height: "25",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 16 19.55",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M16.52,7.68c-.34-2.86-1.94-5-3.93-5S9,4.82,8.66,7.68H4.59V22.27h16V7.68Zm-3.93-3c.79,0,1.64,1.21,1.91,3H10.69C11,5.93,11.81,4.72,12.59,4.72Zm6,15.55h-12V9.68h12Z",
                              transform: "translate(-4.59 -2.72)",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex flex-center align-center",
                          attrs: { id: "cart-quantity-container" },
                        },
                        [
                          _c("span", { attrs: { id: "cart-quantity" } }, [
                            _vm._v(_vm._s(_vm.quantityInCart)),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showPopup
        ? _c(
            "modal",
            {
              on: {
                "hide-modal": function ($event) {
                  _vm.showPopup = false
                },
              },
            },
            [
              _vm.showPopup
                ? _c("div", { staticClass: "modal-mask" }, [
                    _c("div", { staticClass: "modal-wrapper" }, [
                      _c("div", { staticClass: "modal-container" }, [
                        _c("div", { staticClass: "modal-body" }, [
                          _c("img", {
                            staticClass: "talk-to-sales-picture",
                            attrs: {
                              src: "https://images.ctfassets.net/bx9krvy0u3sx/4DYMpsafVECYaSOzV9vubs/4df946875a13de3e7e471127dea483af/phone_img.png",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v("Thank you for your interest in Samsara! "),
                            _c("b", [
                              _vm._v(
                                "We will give you a call on the next business day."
                              ),
                            ]),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "In the meantime, please check out our product catalog"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "modal-default-button",
                              on: {
                                click: function ($event) {
                                  _vm.showPopup = !_vm.showPopup
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Back to Store\n                        "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/2 m-auto" }, [
        _vm.shouldDisplayNavigation
          ? _c("div", { attrs: { id: "checkout-header" } }, [
              _vm._v(_vm._s(_vm.checkoutTitle)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldDisplayNavigation && !_vm.isPmUpdate
          ? _c(
              "div",
              { staticClass: "flex flex-center" },
              _vm._l(_vm.navigationSteps, function (step, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: _vm.checkoutStepClass(index + 1),
                    attrs: { id: "step" + (index + 1) },
                    on: {
                      click: function ($event) {
                        return _vm.determineRouteToUrl(index + 1)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(index + 1) +
                        ". " +
                        _vm._s(step) +
                        "\n            "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "login-button" } }, [
      _c("a", { attrs: { href: "https://cloud.samsara.com/webstore" } }, [
        _vm._v("Login"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }